import React from 'react'
import { Box, Button, Tooltip } from '@mui/material'
import { RadarScanIcon } from 'src/Libs/flow/icons'
import { Emc } from 'src/Libs/flow/installation/forms'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const NetworkScanButton: React.FC<{
  onClick: () => void
  buttonLabel: string
  disabled?: boolean
  title?: string
}> = ({ onClick, buttonLabel, disabled, title }) => {
  return (
    <Button
      color="secondary"
      variant="outlined"
      size="large"
      onClick={onClick}
      disabled={disabled}
      startIcon={<RadarScanIcon />}
      title={title}
      sx={{
        width: { xs: '100%', md: 'auto' },
        lineHeight: 1.1,
      }}
    >
      {buttonLabel}
    </Button>
  )
}

/** Button for starting a network scan in the pairing dialogs */
export const EmcNetworkScanButton: React.FC<{
  installationId: number | null
  emc: Emc | null
  onClick: () => void
  /** Custom label to overwrite the default one. */
  buttonLabel?: string
  disabled?: boolean
}> = ({ installationId, emc, onClick, buttonLabel, disabled }) => {
  const { t } = useCustomTranslation()

  const isDisabled = disabled || installationId === null || !emc || emc.isNew || !emc.isPaired

  // TODO: fix scan button translations
  // ? t("installation.productEditor.pairingEditor.noEmcId")
  return (
    <Tooltip title={useTitle(installationId, emc?.isPaired ?? false)}>
      <Box width={{ xs: '100%', md: 'auto' }}>
        <NetworkScanButton
          buttonLabel={buttonLabel ?? t('installation.productEditor.detect')}
          onClick={onClick}
          disabled={isDisabled}
          title={emc?.isPaired ? undefined : t('installation.productEditor.scanDisabled')}
        />
      </Box>
    </Tooltip>
  )
}

const useTitle = (installationId: number | null, isEmcPaired: boolean): string => {
  const { t } = useCustomTranslation()
  if (!installationId) return t('installation.productEditor.pairingEditor.noInstallationId')
  if (!isEmcPaired) return t('installation.productEditor.scanDisabled')
  return ''
}
